<div class="container-fluid py-3">
  <div class="row">

    <div class="col-12 d-flex align-items-center mb-4">
                      
      @if(years.length > 0 && !movementService.loading) {

        <div class="col-4 pe-1">
          <ng-select
            [items]="years"
            bindLabel="year"
            bindValue="year"
            [(ngModel)]="yearSelected"
            placeholder="Seleccionar año"
            (keyup.enter)="getMovements()"
            (change)="onChangeYear($event)">
          </ng-select>
        </div>

        <div class="col-4 ps-1">
          <ng-select
            [items]="months"
            bindLabel="description"
            bindValue="month"
            [(ngModel)]="monthSelected"
            (keyup.enter)="getMovements()"
            placeholder="Seleccionar mes">
          </ng-select>
        </div>

        <div class="col-4 ps-2">
          <div class="row flex justify-content-end">

            <button
              (click)="getMovements()"
              type="button"
              [disabled]="!yearSelected || !monthSelected || movementService.loading"
              class="btn btn-primary rounded-circle me-2 d-flex align-items-center justify-content-center"
              style="height: 4vh; width: 4vh;">
              <i class="material-icons" style="font-size: calc(0.8rem + 0.8vh);">search</i>
            </button>

            <button
              (click)="downloadReport()"
              type="button"
              [disabled]="!yearSelected || !monthSelected || movementService.loading"
              class="btn btn-primary rounded-circle me-2 d-flex align-items-center justify-content-center"
              style="height: 4vh; width: 4vh;">
              <i class="material-icons" style="font-size: calc(0.8rem + 0.8vh);">
                download
              </i>
            </button>

            <button
              (click)="open()"
              type="button"
              class="btn btn-success rounded-circle me-2 d-flex align-items-center justify-content-center"
              style="height: 4vh; width: 4vh;">
              <i 
                class="material-icons"
                style="font-size: calc(0.8rem + 0.8vh);">
                add
              </i>
            </button>

            <button
              (click)="getMovements()"
              type="button"
              class="btn btn-light rounded-circle me-2 d-flex align-items-center justify-content-center"
              style="height: 4vh; width: 4vh;">
              <i 
                class="material-icons"
                style="font-size: calc(0.8rem + 0.8vh);">
                refresh
              </i>
            </button>

          </div>
        </div>

      }

    </div>

    <div class="col-12 mb-2">
      <div class="row">

        <!-- Balance del mes -->
        <div class="col-6 col-md-4 col-xl-3 mb-3">
          <div class="bg-white rounded-3 shadow-sm p-3 h-100">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <span class="text-secondary fw-500" style="font-size: calc(0.65rem + 0.55vh);">Balance del mes</span>
              <div class="rounded-circle d-flex align-items-center justify-content-center"
                style="height: 2.2rem; width: 2.2rem; background-color: rgba(13,110,253,0.1); flex-shrink: 0;">
                <i class="material-icons text-primary" style="font-size: 1rem;">account_balance</i>
              </div>
            </div>
            @if(movementService.loading) {
              <div class="placeholder-glow">
                <span class="placeholder col-10 rounded" style="height: 1.8rem;"></span>
              </div>
            } @else {
              <div class="fw-bold" style="font-size: calc(1rem + 0.8vh);">
                {{ movementService.insights?.monthBalance?.balance | currency }}
              </div>
            }
          </div>
        </div>

        <!-- Ingresos -->
        <div class="col-6 col-md-4 col-xl-3 mb-3">
          <div class="bg-white rounded-3 shadow-sm p-3 h-100">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <span class="text-secondary fw-500" style="font-size: calc(0.65rem + 0.55vh);">Ingresos del mes</span>
              <div class="rounded-circle d-flex align-items-center justify-content-center"
                style="height: 2.2rem; width: 2.2rem; background-color: rgba(25,135,84,0.1); flex-shrink: 0;">
                <i class="material-icons text-success" style="font-size: 1rem;">arrow_downward</i>
              </div>
            </div>
            @if(movementService.loading) {
              <div class="placeholder-glow">
                <span class="placeholder col-10 rounded bg-success" style="height: 1.8rem;"></span>
              </div>
            } @else {
              <div class="text-success fw-bold" style="font-size: calc(1rem + 0.8vh);">
                {{ movementService.insights?.monthBalance?.income | currency }}
              </div>
            }
          </div>
        </div>

        <!-- Egresos -->
        <div class="col-6 col-md-4 col-xl-3 mb-3">
          <div class="bg-white rounded-3 shadow-sm p-3 h-100">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <span class="text-secondary fw-500" style="font-size: calc(0.65rem + 0.55vh);">Egresos del mes</span>
              <div class="rounded-circle d-flex align-items-center justify-content-center"
                style="height: 2.2rem; width: 2.2rem; background-color: rgba(220,53,69,0.1); flex-shrink: 0;">
                <i class="material-icons text-danger" style="font-size: 1rem;">arrow_upward</i>
              </div>
            </div>
            @if(movementService.loading) {
              <div class="placeholder-glow">
                <span class="placeholder col-10 rounded bg-danger" style="height: 1.8rem;"></span>
              </div>
            } @else {
              <div class="text-danger fw-bold" style="font-size: calc(1rem + 0.8vh);">
                {{ movementService.insights?.monthBalance?.expenses | currency }}
              </div>
            }
          </div>
        </div>

        <!-- Cuentas por pagar -->
        <div class="col-6 col-md-4 col-xl-3 mb-3">
          <div
            class="bg-white rounded-3 shadow-sm p-3 h-100 movementsPage__summaryCard"
            [class.movementsPage__summaryCard--clickable]="canFilterPendingExpenses"
            [class.movementsPage__summaryCard--active]="isPendingExpensesFilterActive"
            [attr.role]="pendingExpensesCardRole"
            [attr.tabindex]="pendingExpensesCardTabIndex"
            [attr.aria-label]="pendingExpensesCardAriaLabel"
            [attr.aria-pressed]="pendingExpensesCardAriaPressed"
            (click)="toggleMovementsFilter('pendingExpenses')"
            (keydown.enter)="toggleMovementsFilter('pendingExpenses', $event)"
            (keydown.space)="toggleMovementsFilter('pendingExpenses', $event)">
            <div class="d-flex justify-content-between align-items-center mb-3 movementsPage__summaryCardHeader">
              <span class="text-secondary fw-500" style="font-size: calc(0.65rem + 0.55vh);">Cuentas por pagar del mes</span>
              <div class="rounded-circle d-flex align-items-center justify-content-center"
                style="height: 2.2rem; width: 2.2rem; background-color: rgba(255,193,7,0.12); flex-shrink: 0;">
                <i class="material-icons text-warning" style="font-size: 1rem;">attach_money</i>
              </div>
            </div>
            @if(movementService.loading) {
              <div class="placeholder-glow">
                <span class="placeholder col-10 rounded bg-warning" style="height: 1.8rem;"></span>
              </div>
            } @else {
              <div class="fw-bold" style="font-size: calc(1rem + 0.8vh);">
                {{ movementService.insights?.monthBalance?.pendingExpenses | currency }}
              </div>
            }
          </div>
        </div>

        <!-- Cobros pendientes -->
        <div class="col-6 col-md-4 col-xl-3 mb-3">
          <div
            class="bg-white rounded-3 shadow-sm p-3 h-100 movementsPage__summaryCard"
            [class.movementsPage__summaryCard--clickable]="canFilterPendingIncome"
            [class.movementsPage__summaryCard--active]="isPendingIncomeFilterActive"
            [attr.role]="pendingIncomeCardRole"
            [attr.tabindex]="pendingIncomeCardTabIndex"
            [attr.aria-label]="pendingIncomeCardAriaLabel"
            [attr.aria-pressed]="pendingIncomeCardAriaPressed"
            (click)="toggleMovementsFilter('pendingIncome')"
            (keydown.enter)="toggleMovementsFilter('pendingIncome', $event)"
            (keydown.space)="toggleMovementsFilter('pendingIncome', $event)">
            <div class="d-flex justify-content-between align-items-center mb-3 movementsPage__summaryCardHeader">
              <span class="text-secondary fw-500" style="font-size: calc(0.65rem + 0.55vh);">Cobros pendientes del mes</span>
              <div class="rounded-circle d-flex align-items-center justify-content-center"
                style="height: 2.2rem; width: 2.2rem; background-color: rgba(111,66,193,0.1); flex-shrink: 0;">
                <i class="material-icons" style="font-size: 1rem; color: #6f42c1;">history</i>
              </div>
            </div>
            @if(movementService.loading) {
              <div class="placeholder-glow">
                <span class="placeholder col-10 rounded" style="height: 1.8rem; background-color: rgba(111,66,193,0.3);"></span>
              </div>
            } @else {
              <div class="fw-bold" style="font-size: calc(1rem + 0.8vh);">
                {{ movementService.insights?.monthBalance?.pendingIncome | currency }}
              </div>
            }
          </div>
        </div>

        <!-- Balance total -->
        <div class="col-6 col-md-4 col-xl-3 mb-3">
          <div class="bg-white rounded-3 shadow-sm p-3 h-100">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <span class="text-secondary fw-500" style="font-size: calc(0.65rem + 0.55vh);">Balance total</span>
              <div class="rounded-circle d-flex align-items-center justify-content-center"
                style="height: 2.2rem; width: 2.2rem; background-color: rgba(13,110,253,0.1); flex-shrink: 0;">
                <i class="material-icons text-primary" style="font-size: 1rem;">account_balance_wallet</i>
              </div>
            </div>
            @if(movementService.loading) {
              <div class="placeholder-glow">
                <span class="placeholder col-10 rounded" style="height: 1.8rem;"></span>
              </div>
            } @else {
              <div class="fw-bold" style="font-size: calc(1rem + 0.8vh);">
                {{ movementService.insights?.totalBalance?.balance | currency }}
              </div>
            }
          </div>
        </div>

        <!-- Crédito en casas -->
        <div class="col-6 col-md-4 col-xl-3 mb-3">
          <div
            class="bg-white rounded-3 shadow-sm p-3 h-100 movementsPage__summaryCard"
            [class.movementsPage__summaryCard--clickable]="canOpenHousesWithCredit"
            [attr.role]="creditCardRole"
            [attr.tabindex]="creditCardTabIndex"
            [attr.aria-label]="creditCardAriaLabel"
            (click)="goToHousesWithCredit()"
            (keydown.enter)="goToHousesWithCredit($event)"
            (keydown.space)="goToHousesWithCredit($event)">
            <div class="d-flex justify-content-between align-items-center mb-3 movementsPage__summaryCardHeader">
              <span class="text-secondary fw-500" style="font-size: calc(0.65rem + 0.55vh);">Crédito en casas</span>
              <div class="rounded-circle d-flex align-items-center justify-content-center"
                style="height: 2.2rem; width: 2.2rem; background-color: rgba(255,193,7,0.12); flex-shrink: 0;">
                <i class="material-icons text-warning" style="font-size: 1rem;">savings</i>
              </div>
            </div>
            @if(movementService.loading) {
              <div class="placeholder-glow">
                <span class="placeholder col-10 rounded bg-warning" style="height: 1.8rem;"></span>
              </div>
            } @else {
              <div class="fw-bold" style="font-size: calc(1rem + 0.8vh);">
                {{ movementService.creditSummary?.totalCreditBalance | currency }}
              </div>
              <div class="text-secondary mt-1" style="font-size: calc(0.6rem + 0.5vh);">
                {{ movementService.creditSummary?.housesWithCredit }} casas con crédito
              </div>
            }
          </div>
        </div>

        <!-- Crédito usado -->
        <div class="col-6 col-md-4 col-xl-3 mb-3">
          <div class="bg-white rounded-3 shadow-sm p-3 h-100">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <span class="text-secondary fw-500" style="font-size: calc(0.65rem + 0.55vh);">Crédito usado</span>
              <div class="rounded-circle d-flex align-items-center justify-content-center"
                style="height: 2.2rem; width: 2.2rem; background-color: rgba(13,202,240,0.12); flex-shrink: 0;">
                <i class="material-icons text-info" style="font-size: 1rem;">account_balance_wallet</i>
              </div>
            </div>
            @if(movementService.loading) {
              <div class="placeholder-glow">
                <span class="placeholder col-10 rounded bg-info" style="height: 1.8rem;"></span>
              </div>
            } @else {
              <div class="fw-bold" style="font-size: calc(1rem + 0.8vh);">
                {{ movementService.insights?.monthBalance?.creditApplied | currency }}
              </div>
            }
          </div>
        </div>

      </div>
    </div>

    <!-- <div class="col-12 col-lg-7 col-xl-8 mb-4">

      <div class="card">
        <p-chart type="bar" [data]="data" [options]="options" />
      </div>

    </div>

    <div class="col-12 col-lg-5 col-xl-4 mb-4">
      <div class="card flex justify-content-center">
        <p-chart type="doughnut" [data]="dataMonth" [options]="optionsMonth" />
      </div>
    </div> -->

    <div class="col-12">

        <p-table #dt
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [filterDelay]="0"
            [loading]="movementService.loading"
            [paginator]="true"
            [rows]="10"
            [rowHover]="true"
            [rowsPerPageOptions]="[10,25,50]"
            [showCurrentPageReport]="true" 
            [value]="movementsFiltered"
            pDroppable="row">
            <ng-template pTemplate="caption">
              <div class="container-fluid px-0">
                <div class="row align-items-center">

                  <div class="col-12 col-lg-3 d-flex align-items-center mb-2 mb-lg-0 movementsPage__captionCol">
                    <span class="fw-semibold text-truncate">Estado de cuenta</span>
                  </div>

                  <div class="col-12 col-lg-6 mb-2 mb-lg-0 movementsPage__captionCol">

                    <div class="input-group movementsPage__search">

                      <span class="input-group-text bg-white border-end-0 text-secondary movementsPage__searchAddon">
                        <i class="material-icons" aria-hidden="true">search</i>
                      </span>

                      <input
                        #movementsSearchInput
                        type="search"
                        class="form-control border-start-0 movementsPage__searchInput"
                        [class.border-end-0]="movementsSearch.length > 0"
                        placeholder="Buscar movimiento..."
                        autocomplete="off"
                        aria-label="Buscar movimiento por descripción, notas, fecha, estatus o cantidad"
                        [ngModel]="movementsSearch"
                        (ngModelChange)="onMovementsSearchChange($event)"
                        (keydown.escape)="clearMovementsSearch(movementsSearchInput)">

                      @if(movementsSearch.length > 0) {

                        <button
                          (click)="clearMovementsSearch(movementsSearchInput)"
                          type="button"
                          ngbTooltip="Limpiar búsqueda"
                          container="body"
                          aria-label="Limpiar búsqueda"
                          class="btn movementsPage__searchClear">
                          <i class="material-icons" aria-hidden="true">close</i>
                        </button>

                      }

                    </div>

                  </div>

                  <div class="col-12 col-lg-3 text-end mb-2 mb-lg-0 movementsPage__captionCol">

                    <button
                      (click)="clearMovementsFilter()"
                      type="button"
                      [disabled]="!canClearMovementsFilter"
                      ngbTooltip="Limpiar filtros"
                      container="body"
                      aria-label="Limpiar filtros"
                      class="btn btn-light rounded-circle me-2">
                      <i class="material-icons mt-1">filter_alt_off</i>
                    </button>

                  </div>

                </div>
              </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>

                  <th></th>

                  <th pSortableColumn="description">
                    Descripción
                    <p-sortIcon field="description"></p-sortIcon>
                    <p-columnFilter type="text" field="description" display="menu"></p-columnFilter>
                  </th>

                  <th>
                    Cantidad
                    <p-sortIcon field="amount"></p-sortIcon>
                    <p-columnFilter type="number" field="amount" display="menu"></p-columnFilter>
                  </th>

                  <th pSortableColumn="status">
                    Estatus
                    <p-sortIcon field="status"></p-sortIcon>
                  </th>

                  <th>
                    Fecha
                    <p-sortIcon field="createdAt"></p-sortIcon>
                    <p-columnFilter type="date" field="createdAt" display="menu"></p-columnFilter>
                  </th>

                  <th >
                    Comprobante
                  </th>

                  <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-movement let-rowIndex="rowIndex">
                <tr class="p-selectable-row">

                  <td>
                    @if(movement.paymentMethodCode === 'credit') {
                      <i class="material-icons mt-1 text-info">savings</i>
                    } @else if(movement.movementType) {
                      <i class="material-icons mt-1 text-success">arrow_downward</i>
                    } @else {
                      <i class="material-icons mt-1 text-danger">arrow_upward</i>
                    }
                  </td>

                  <td>
                    <span class="p-column-title">Descripción</span>
                    {{movement.description}} {{ movement.notes != '' ? "(" + movement.notes + ")" : '' }}
                  </td>

                  <td
                    [ngClass]="{
                      'text-success': movement.movementType && movement.status,
                      'text-danger': !movement.movementType && movement.status,
                      'text-secondary': !movement.status
                    }">
                    <span class="p-column-title">Cantidad</span>
                    {{ !movement.movementType ? '-' : '' }}{{ movement.amount | currency }}
                  </td>

                  <td>
                    <span class="p-column-title">Estatus</span>

                    @if(movement.paymentMethodCode) {
                      <span class="badge rounded-pill text-bg-info">{{ movement.paymentMethod?.name }}</span>
                    } @else if(movement.movementType && movement.status) {
                      <span class="badge rounded-pill text-bg-success">{{ movement.statusDescription }}</span>
                    } @else if(!movement.movementType && movement.status) {
                      <span class="badge rounded-pill text-bg-danger">{{ movement.statusDescription }}</span>
                    } @else {
                      <span class="badge rounded-pill text-bg-secondary">{{ movement.statusDescription }}</span>
                    }
                  </td>

                  <td>
                    <span class="p-column-title">Fecha</span>
                    {{movement.createdAt | dateToMoment: 'DD MMM yyyy' : neighborhoodService.currentNeighborhood?.timeZone }}
                  </td>

                  <td>
                    <i 
                      class="material-icons mt-1"
                      [ngClass]="{
                        'text-success': movement.fileId,
                        'text-danger': !movement.fileId
                      }">
                      @if(movement.fileId) {
                        done
                      } @else {
                        close
                      }
                    </i>
                  </td>

                  <td>

                    <button
                      (click)="open(movement)"
                      class="btn btn-sm btn-light rounded-circle me-2 my-1">
                      <i class="material-icons mt-1">edit</i>
                    </button>

                    <button
                      (click)="delete(movement)"
                      class="btn btn-sm btn-danger rounded-circle me-2 my-1">
                      <i class="material-icons mt-1">delete</i>
                    </button>
                  </td>
                </tr>
            </ng-template>
        </p-table>

    </div>

  </div>
</div>